/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Orthopaedic_Rehab_TermsInputs */

const en_service_type_orthopaedic_rehab_terms = /** @type {(inputs: Service_Type_Orthopaedic_Rehab_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rehab, injury, knee, shoulder, elbow, wrist, hip, ankle, foot, sprain, tendon, ligament, acl, meniscus, back pain, spine, sciatica, neck pain`)
};

const pl_service_type_orthopaedic_rehab_terms = /** @type {(inputs: Service_Type_Orthopaedic_Rehab_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rehabilitacja, rehab, kontuzja, uraz, kolano, bark, ramię, łokieć, nadgarstek, biodro, kostka, stopa, skręcenie, zwichnięcie, ścięgno, więzadło, acl, łąkotka, ból pleców, kręgosłup, dyskopatia, rwa kulszowa, szyja, ból karku`)
};

/**
* | output |
* | --- |
* | "rehab, injury, knee, shoulder, elbow, wrist, hip, ankle, foot, sprain, tendon, ligament, acl, meniscus, back pain, spine, sciatica, neck pain" |
*
* @param {Service_Type_Orthopaedic_Rehab_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_orthopaedic_rehab_terms = /** @type {((inputs?: Service_Type_Orthopaedic_Rehab_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Orthopaedic_Rehab_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_orthopaedic_rehab_terms(inputs)
	return en_service_type_orthopaedic_rehab_terms(inputs)
});